<template>
  <div class="max-w-md mx-auto mt-10 p-6 border border-gray-200 rounded-lg bg-gray-50">
    <h2 class="text-gray-700 text-xl font-semibold mb-4">ProgressContainer 测试界面</h2>
    <ProgressContainer :percent="percent" :status="status" >
      <div class="p-4 bg-white rounded overflow-hidden flex flex-col justify-center items-center" style="height:400px">
        <p class="text-gray-700">当前进度：{{ percent }}%</p>
        <p class="text-gray-500">状态：{{ status }}</p>
      </div>
    </ProgressContainer>
    <div class="mt-6 flex gap-3">
      <button @click="startProgress" class="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition">开始</button>
      <button @click="finishProgress" class="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition">完成</button>
      <button @click="failProgress" class="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition">失败</button>
      <button @click="resetProgress" class="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500 transition">重置</button>
    </div>
  </div>
</template>

<script>
import ProgressContainer from "@/components/ProgressContainer.vue";

export default {
  name: "DemoProgress",
  components: {
    ProgressContainer
  },
  data() {
    return {
      percent: null,
      status: "active",
      interval: null
    };
  },
  methods: {
    startProgress() {
      this.status = "active";
      this.percent = 0;
      if (this.interval) clearInterval(this.interval);
      this.interval = setInterval(() => {
        if (this.percent < 100) {
          this.percent += 10;
        } else {
          clearInterval(this.interval);
          this.interval = null;
          this.status = "success";
        }
      }, 300);
    },
    finishProgress() {
      if (this.interval) clearInterval(this.interval);
      this.percent = 100;
      this.status = "success";
    },
    failProgress() {
      if (this.interval) clearInterval(this.interval);
      this.percent = 100;
      this.status = "error";
    },
    resetProgress() {
      if (this.interval) clearInterval(this.interval);
      this.percent = null;
      this.status = "active";
    }
  },
  beforeDestroy() {
    if (this.interval) clearInterval(this.interval);
  }
};
</script>
